<template>
  <ul class="todo-list">
    <slot />
  </ul>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
.todo-list {
  @apply flex flex-col;
  @apply divide-y divide-primary-100;
}
</style>
